import EventListener from '@/services/EventListener/EventListener'
import type { TabsSyncMessages } from './constants'
import type { ITabsSyncMessage, TabsSyncEventMap, TabsSyncPayloadMap } from './ITabsSync'

const CHANNEL_NAME = 'youchat-tabs-sync'

/**
 * Cross-tab messaging over the native BroadcastChannel API.
 * When BroadcastChannel is unavailable (old browsers) the instance is inert:
 * it neither receives nor sends, so callers keep working without a feature check.
 */
export default class TabsSync extends EventListener<TabsSyncEventMap> {
  private _channel: BroadcastChannel | null = null

  constructor() {
    super()
    if (typeof BroadcastChannel === 'undefined') {
      return
    }
    this._onMessage = this._onMessage.bind(this)
    this._channel = new BroadcastChannel(CHANNEL_NAME)
    this._channel.addEventListener('message', this._onMessage)
  }

  private _onMessage(event: MessageEvent<ITabsSyncMessage>) {
    this.emit(event.data.type, event.data.payload)
  }

  send<Key extends TabsSyncMessages>(type: Key, payload?: TabsSyncPayloadMap[Key]) {
    if (!this._channel) {
      return
    }
    this._channel.postMessage({ type, payload })
  }

  destroy() {
    this._channel?.close()
  }
}
